import { Column, EmployeeShift } from "@shared-ui-components/DataTable/types";
import { formatUtcToEst } from "@src/utils/formatUtcToEst";

// Functions
export const refineData = (data: EmployeeShift[]) => {
  const refined = data?.map((el: any) => {
    const refinedObject = {
      name: el.name,
      job: el.job,
      clockIn: formatUtcToEst(el.clock_in),
      clockOut: formatUtcToEst(el.clock_out),
      shiftTime: el.shift_time,
      overtime: el.isOvertime,
      total: el.total,
    };
    return refinedObject;
  });
  return refined;
};

// Constants
export const columns: Column[] = [
  { id: "name", label: "Employee", minWidth: 106 },
  { id: "shiftTime", label: "Shift Time", minWidth: 124, alert: true },
  { id: "job", label: "Job", minWidth: 100 },
  { id: "clockIn", label: "Clock In", minWidth: 100 },
  { id: "clockOut", label: "Clock Out", minWidth: 102 },
];

export const filterOptions = [
  { label: "By Recent First", value: "all" },
  { label: "By Overtime", value: "overtime" },
];
